// extracted by mini-css-extract-plugin
module.exports = {"ageRestrictionLogo":"ALc9"};